export enum EmploymentType {
    Employed = "Employed",
    SelfEmployedOverThreeYears = "SelfEmployedOverThreeYears",
    SelfEmployedUnderThreeYears = "SelfEmployedUnderThreeYears",
    Unknown = "Unknown"
}

export default EmploymentType;
